import {
  TFilterDefaultLayers,
  TFilterValuePredicate,
} from '@/shared/features/filter-preferences/utils/resolve-filter-defaults/resolve-filter-defaults.types';
import { TFilterDefaults } from '@/shared/types/ui-preferences.types';

// A key that exists (including '') wins; an absent key falls through to the next layer.
const read = (
  filters: Record<string, string> | undefined,
  param: string,
): string | undefined =>
  filters && param in filters ? filters[param] : undefined;

// A stored default exists on this layer — '' (explicitly cleared) counts.
export const hasLayerDefault = (
  defaults: TFilterDefaults | undefined,
  scopeKey: string,
  param: string,
): boolean => read(defaults?.[scopeKey]?.filters, param) !== undefined;

const ANY_VALUE: TFilterValuePredicate = () => true;

// A per-param default is the more specific choice, so it outranks the saved view
// it sits next to; both outrank the company layer. A disallowed value falls through.
export const resolveFilterDefault = (
  scopeKey: string,
  param: string,
  codeDefault: string | undefined,
  { user, company }: TFilterDefaultLayers,
  isAllowed = ANY_VALUE,
): string | undefined => {
  const layers = [
    user?.[scopeKey]?.filters,
    user?.[scopeKey]?.view?.filters,
    company?.[scopeKey]?.filters,
  ];

  for (const filters of layers) {
    const value = read(filters, param);
    if (value !== undefined && isAllowed(param, value)) return value;
  }

  return codeDefault;
};
